// String values match the IModuleAccess keys exactly so that
// settings.modules[CompanyModule.X] stays type-safe.
export enum CompanyModule {
  EMPLOYER_BRANDING = 'employerBranding',
  ONBOARDING = 'onboarding',
  PERFORMANCE_MANAGEMENT = 'performanceManagement',
}
